import React from "react";
import RecepcionBodegaView from "../../views/adminView/recepcionBodega/RecepcionBodega";

export default function RecepcionBodega() {
  return <RecepcionBodegaView />;
}
